import { ReactNode } from 'react'

import iconSettingsAltSrc from '@cowprotocol/assets/images/icon-settings-alt.svg'

import SVG from 'react-inlinesvg'

export function SettingsIcon(): ReactNode {
  return <SVG src={iconSettingsAltSrc} />
}
